export const REMAINS_TABLE_KEY = 'remains';
